// src/Components/RouteLoader.js
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function RouteLoader() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // כל שינוי בנתיב → מציגים לודר קצר
    setLoading(true);
    const t = setTimeout(() => setLoading(false), 400); // 0.4 שניות מרגיש "snappy"
    return () => clearTimeout(t);
  }, [location.pathname]);

  if (!loading) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        zIndex: 9999,
        background: "linear-gradient(90deg, #111 0%, #777 50%, #111 100%)",
        boxShadow: "0 0 6px rgba(0,0,0,0.25)",
      }}
    />
  );
}
